import React from 'react'
import { useNavigate  } from "react-router-dom";

export const Documents = () => {

  let navigate = useNavigate(); 
  const routeChange = () =>{ 
    navigate('/');
  }

  return (
    <div style={{textAlign: 'center'}}>
    <h1>
      Documents
    </h1>
    <button onClick={routeChange}>
      Back
    </button>
  </div>
  )
}


